var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.677,
    height: 80.146,
    viewBox: "0 0 136.677 80.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55307",
    "data-name": "Group 55307",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5204",
    "data-name": "Path 5204",
    d: "M52.5,8.646l23.8-63.419V8.646h11.92V-71.5H70.334L46.948-8.04,23.067-71.5H5.684V8.646H17.6V-54.773L41.4,8.646Z",
    transform: "translate(-5.684 71.5)",
    fill: "#090b0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5205",
    "data-name": "Path 5205",
    d: "M3.116-71.5,21.289-21.095h8.556L48.067-71.5H39.951L25.682-29.573,11.155-71.5Z",
    transform: "translate(87.897 100.318)",
    fill: "#090b0a",
    stroke: "#090b0a",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv);
export default __webpack_public_path__ + "static/media/mv.e5643f77e2d3074e74ca8e68a30334eb.svg";
export { ForwardRef as ReactComponent };